import React from 'react';
import PropTypes from 'prop-types';

import { css, StyleSheet } from 'aphrodite';

import { BrandProductOutlierCleanupStatus } from 'lib/enums/BrandProductOutlierCleanupStatus';
import Container from 'components/shared/Container';
import DashboardWidget from 'components/dashboard/DashboardWidget';
import DashboardWidgetType from 'lib/enums/DashboardWidgetTypes';
import { squidInk } from 'lib/css/colors';

const TILES = [
  {
    label: 'Pending',
    widgetType: DashboardWidgetType.OUTLIER_CLEANUP_PENDING,
    status: BrandProductOutlierCleanupStatus.PENDING,
  },
  {
    label: 'Sent for Detection',
    widgetType: DashboardWidgetType.OUTLIER_CLEANUP_SENT_FOR_DETECTION,
    status: BrandProductOutlierCleanupStatus.SENT_FOR_OUTLIER_DETECTION,
  },
  {
    label: 'Cleaned',
    widgetType: DashboardWidgetType.OUTLIER_CLEANUP_CLEANED,
    status: BrandProductOutlierCleanupStatus.CLEANED,
  },
];

function BrandOutlierCleanupStatsSection({ counts = {}, loading = false }) {
  return (
    <Container className={css(styles.section)}>
      <h2 className={css(styles.title)}>Product Outlier Cleanup</h2>
      <div className={css(styles.grid)}>
        {TILES.map(tile => (
          <DashboardWidget
            key={tile.label}
            label={tile.label}
            widgetType={tile.widgetType}
            totalCount={counts[tile.status] ?? 0}
            percentageChange={0}
            dateDifference={7}
            loading={loading}
          />
        ))}
      </div>
    </Container>
  );
}

const styles = StyleSheet.create({
  section: {
    padding: '20px',
  },
  title: {
    fontSize: 18,
    fontWeight: 600,
    color: squidInk,
    marginBottom: 16,
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))',
    gap: 20,
  },
});

BrandOutlierCleanupStatsSection.propTypes = {
  counts: PropTypes.object,
  loading: PropTypes.bool,
};

export default BrandOutlierCleanupStatsSection;
